<template>
    <div class="popup popup-starrySky" :class="{ 'modal-in': isShow, 'modal-out': !isShow}">
        <div class="js-smartScroll" style="position: relative;height: 100%;">
            <div @click="goBack" class="promo-popup-close starrySky_tag_cancel" style="position: absolute; right: 10px;top: 10px;width: 30px;z-index: 1;">
                <img src="https://resource.rcclchina.com.cn/cruiseSearch/popup/popup_close.png" style="width: 100%;">
            </div>
            <div class="promo-popup-content js-smartScroll" style="height: 100%;overflow: scroll;top: 0;">
                <img style="width: 100%;margin: auto;display: block;" :src="themeInfo?.roomPopupImgUrlMB">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomThemePopup',
    props: {
      themeInfo: {
        type: Object
      },
      onGoBack: {
        type: Function
      },
      isShow: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    methods: {
        goBack () {
            this.onGoBack()
        }
    }
}
</script>

<style lang="less" scoped>
.popup {
    position: fixed;
    display: block;
    opacity: 0;
}
.popup.modal-in{
    opacity: 100;
}
</style>
